var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBars(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 21.059",
    fill: "#277982",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 2.33,
    rx: 1.165
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 2.33,
    rx: 1.165,
    y: 9.367
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 2.33,
    rx: 1.165,
    y: 18.729
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default ForwardRef;